import { Routes, Route } from "react-router-dom";

import TopNavbar from "./components/TopNavbar/TopNavbar";
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";

import Home from "./pages/Home";
import About from "./pages/About";
import Blog from "./pages/Blog";
import Contact from "./pages/Contact";
import FindProfessional from "./pages/FindProfessional";
import RegisterProfessional from "./pages/RegisterProfessional";
import SearchResults from "./pages/SearchResults";
import OurProducts from "./pages/OurProducts";
import Brands from "./pages/Brands";

function App() {
  return (
    <>
      <TopNavbar />
      <Navbar />

      <Routes>
        <Route path="/" element={<Home />} />

        <Route path="/our-products" element={<OurProducts />} />
        <Route path="/brands" element={<Brands />} />

        <Route path="/find-professional" element={<FindProfessional />} />
        <Route
          path="/register-professional"
          element={<RegisterProfessional />}
        />
        <Route path="/about" element={<About />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/search-results" element={<SearchResults />} />
      </Routes>

      <Footer />
    </>
  );
}

export default App;